import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material"
import Stepper from "./Stepper"
import { useDispatch, useSelector } from "react-redux"
import { getMainForm, jumpState, setField } from "../../../redux/slices/mainFormSlice"
import { useFormInputValidation } from "react-form-input-validation"

export default function OthersStep() {
  const {
    config: { inputs },
    comments,
    previous_workshops,
    motivation,
    newsletters,
  } = useSelector(getMainForm)
  const dispatch = useDispatch()

  // Champs ajoutés après la création des premiers formulaires : absents de
  // inputs sur les anciens documents → affichés par défaut (comme côté API)
  const showPreviousWorkshops = (inputs["previous_workshops"] ?? 1) > 0
  const showMotivation = (inputs["motivation"] ?? 1) > 0

  const [fields, errors, form] = useFormInputValidation(
    {
      previous_workshops: previous_workshops ?? "",
      motivation: motivation ?? "",
      comments: comments ?? "",
      newsletters: newsletters ?? "",
    },
    {
      previous_workshops: `string|max:500${inputs["previous_workshops"] === 2 ? "|required" : ""}`,
      motivation: `string|max:500${inputs["motivation"] === 2 ? "|required" : ""}`,
      comments: `string|max:128${inputs["comments"] === 2 ? "|required" : ""}`,
      newsletters: `boolean${inputs["newsletters"] === 1 ? "|required" : ""}`,
    }
  )

  const onChange = (event) => form.validate(event)

  const nextStep = (event) => {
    form.validate(event).then((isValid) => {
      if (isValid) {
        Object.keys(fields).forEach((field) => {
          dispatch(
            setField({
              superField: null,
              field: field,
              newValue: fields[field],
            })
          )
        })

        dispatch(jumpState(1))
      }
    })
    // event
    // dispatch(jumpState(1))
  }
  return (
    <form onChange={onChange} noValidate autoComplete="off" onSubmit={nextStep}>
      <Stepper />
      <Box sx={{ my: 2 }} />
      <Card sx={{ p: 1 }}>
        <CardHeader title={"Informations supplémentaires"} />
        <CardContent sx={{ display: "flex", gap: 1, flexDirection: "column" }}>
          {showPreviousWorkshops && (
            <Box>
              <Typography sx={{ mb: 1 }}>
                {"Avez-vous déjà participé à un/des atelier(s) Jeune public sur le thème de la technique (HEIG-VD, CPNV, EPFL...) et si oui le(s)quel(s) ?"}
                {inputs["previous_workshops"] === 2 && " *"}
              </Typography>
              {/* rows fixe + textarea natif : TextareaAutosize (multiline auto) rend un 2e
                  textarea caché sans name, sur lequel react-form-input-validation crashe
                  (null.endsWith) et bloque la soumission */}
              <TextField
                fullWidth
                multiline
                rows={2}
                InputProps={{ inputComponent: "textarea" }}
                name={"previous_workshops"}
                placeholder={"Votre réponse"}
                value={fields["previous_workshops"]}
                onBlur={form.handleBlurEvent}
                onChange={form.handleChangeEvent}
                error={!!errors["previous_workshops"]}
                helperText={errors["previous_workshops"] ?? " "}
              />
            </Box>
          )}
          {showMotivation && (
            <Box>
              <Typography sx={{ mb: 1 }}>
                {"Motivation : expliquez en quelques mots pourquoi vous souhaitez participer à ce stage et quel est votre lien avec le monde de la technique."}
                {inputs["motivation"] === 2 && " *"}
              </Typography>
              <TextField
                fullWidth
                multiline
                rows={2}
                InputProps={{ inputComponent: "textarea" }}
                name={"motivation"}
                placeholder={"Votre réponse"}
                value={fields["motivation"]}
                onBlur={form.handleBlurEvent}
                onChange={form.handleChangeEvent}
                error={!!errors["motivation"]}
                helperText={errors["motivation"] ?? " "}
              />
            </Box>
          )}
          {inputs["comments"] > 0 && (
            <Box>
              <Typography sx={{ mb: 1 }}>
                {"Commentaires : avez-vous une remarque ou une information à nous transmettre ?"}
                {inputs["comments"] === 2 && " *"}
              </Typography>
              <TextField
                fullWidth
                multiline
                rows={2}
                InputProps={{ inputComponent: "textarea" }}
                name={"comments"}
                placeholder={"Votre réponse"}
                value={fields["comments"]}
                onBlur={form.handleBlurEvent}
                onChange={form.handleChangeEvent}
                error={!!errors["comments"]}
                helperText={errors["comments"] ?? " "}
              />
            </Box>
          )}
          {inputs["newsletters"] > 0 && (
            <FormControl error={!!errors["newsletters"]} required={inputs["newsletters"] === 1}>
              <Divider
                textAlign={"left"}
                sx={
                  errors["newsletters"]
                    ? {
                        "&::before, &::after": {
                          borderColor: "error.main",
                        },
                      }
                    : {}
                }
              >
                <FormLabel id={"radiosButtonsNewsletters"}>Newsletters</FormLabel>
              </Divider>
              <RadioGroup sx={{ pl: "14.5px", alignItems: "center", gap: 4 }} value={fields["newsletters"]} row>
                <Typography>Souhaitez-vous recevoir des emails pour être informé des futurs ateliers ?</Typography>
                <Box>
                  <FormControlLabel control={<Radio name="newsletters" onChange={form.handleChangeEvent} value={true} />} label={"Oui"} />
                  <FormControlLabel control={<Radio name="newsletters" onChange={form.handleChangeEvent} value={false} />} label={"Non"} />
                </Box>
              </RadioGroup>
              <FormHelperText color={"error"}>{errors["newsletters"] ?? " "}</FormHelperText>
            </FormControl>
          )}
        </CardContent>
      </Card>
    </form>
  )
}
